export default __webpack_public_path__ + "static/media/sy-gcsj.8e6e813e.png";